export default __webpack_public_path__ + "static/media/openid.5bd27ff9.svg";